import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import {
  H1,
  H2,
  P,
  Input,
  NextStep,
  PrimaryAnchor,
  PrevNextStep,
  InputSVGContainer,
} from "../general/GeneralStyles"
import CheckboxSwitch from "../general/CheckboxSwitch"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const FormGrid = styled.div`
  width: 95%;
  max-width: 550px;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    ${Input} {
      width: 48%;
    }
  }

  label {
    width: 80%;
    display: inline-block;
  }

  ${P} {
    display: inline-block;
    margin-bottom: 0;
    margin-left: 5%;
  }
`

const LearnMoreLink = styled(Link)`
  color: ${props => props.theme.primaryColor};
  text-decoration: none;
`

const Step2 = props => {
  const inputValidation = () => {
    if (!props.formData.name || !props.formData.dob) {
      alert("Please fill all the fields to continue")
    } else {
      console.log("Step 2 props.formData: " + props.formData)
      props.setStep(3)
    }
  }

  const roleHandler = e => {
    if (e.target.checked) {
      props.setFormData({ ...props.formData, role: "contributor" })
    } else {
      props.setFormData({ ...props.formData, role: "admin" })
    }
  }

  return (
    <>
      <H1>Sign Up</H1>
      <H2>
        <span>Step 2:</span> Tell Us About Yourself
      </H2>
      <FormGrid>
        <div>
          <Input
            type="text"
            placeholder="Your Name"
            name="name"
            value={props.formData.name}
            onChange={props.inputHandler}
            required
          />
          <InputSVGContainer>
            <FontAwesomeIcon icon="birthday-cake" />
            <Input
              type="date"
              placeholder="Birth Date"
              name="dob"
              value={props.formData.dob}
              onChange={props.inputHandler}
              required
            />
          </InputSVGContainer>
        </div>
        <CheckboxSwitch onClick={roleHandler} />
        <P>
          <LearnMoreLink to="/privacy-policy/">Learn More</LearnMoreLink>
        </P>
        <PrevNextStep>
          <PrimaryAnchor href="#" onClick={() => props.setStep(1)}>
            {"<"} &nbsp;&nbsp; Previous Step
          </PrimaryAnchor>
          <NextStep href="#" onClick={inputValidation}>
            Next Step
          </NextStep>
        </PrevNextStep>
      </FormGrid>
    </>
  )
}

export default Step2
